// src/utils/dateHelpers.js

/**
 * Mengubah objek Date menjadi string format YYYY-MM-DD
 * @param {Date} date - Objek Date yang akan diformat
 * @returns {string} - Tanggal dalam format YYYY-MM-DD
 */
export const formatDateToString = (date) => {
    return date.toISOString().split('T')[0];
};

// src/utils/dateHelpers.js

/**
 * Mengubah string tanggal (format YYYY-MM-DD) menjadi format DD-Month-YYYY (contoh: 10-September-2024)
 * @param {string} dateString - String tanggal dalam format YYYY-MM-DD
 * @returns {string} - Tanggal dalam format DD-Month-YYYY
 */
export const formatDateToDayMonthYear = (dateString) => {
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

// src/utils/dateHelpers.js

/**
 * Mengubah string tanggal (format YYYY-MM-DD) menjadi format DD-Month-YYYY (contoh: 10-Sept-2024)
 * @param {string} dateString - String tanggal dalam format YYYY-MM-DD
 * @returns {string} - Tanggal dalam format DD-Month-YYYY
 */
export const formatDateToDayMonthYearShort = (dateString) => {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
    ];

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};


export const convertToHi = (timeString) => {
    const [hours, minutes] = timeString.split(":");
    return `${hours}:${minutes}`;
}


export const formatDateTimeToReadableIndo = (
    isoString,
    timeZone = "Asia/Makassar"
  ) => {
    try {
      return new Date(isoString).toLocaleString("id-ID", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone,
        hour12: false,
      });
    } catch (e) {
      return "-";
    }
  };